"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function urlParamsToObj(value) {
    if (!value) {
        return {};
    }
    return value
        .replace(/[?]/g, '')
        .split('&')
        .map(function (param) {
        var _a;
        var _b = param.split('='), key = _b[0], value = _b[1];
        return _a = {}, _a[key] = value, _a;
    })
        .reduce(function (acc, param) {
        return __assign(__assign({}, acc), param);
    }, {});
}
exports.urlParamsToObj = urlParamsToObj;
function objToUrlParams(value) {
    if (!value) {
        return '';
    }
    var queryString = Object.keys(value)
        .map(function (key) { return key + "=" + value[key]; })
        .join('&');
    return queryString;
}
exports.objToUrlParams = objToUrlParams;
